import { useContext } from '../../_snowpack/pkg/react.js';
import { FeatureFlagsState, FeatureFlagsActions } from '../gates/feature-flags-gate.js';
export const useFeatureFlags = () => useContext(FeatureFlagsState);
export const useFeatureFlagsActions = () => useContext(FeatureFlagsActions);